// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77a8a04f","455":"4f559584","644":"699bee31"}[chunkId] + ".chunk.js";
};